module.exports = __webpack_public_path__ + "img/smiling-face-with-sunglasses.e3df4c2a.svg";